import styled from 'styled-components/macro';
import { baseSpacing } from 'css/constants';

const RadioLabel = styled.label`
  display: ${({ inline }) => (inline ? 'inline-flex' : 'flex')};
  align-items: center;

  ${({ inline }) =>
    inline &&
    `& + & {
      margin-left: ${baseSpacing / 2}px;
    }`}

  & > span {
    margin-left: ${baseSpacing / 4}px;
  }
`;

export default RadioLabel;
